// extracted by mini-css-extract-plugin
export default {"container":"banEhJTe7TF70mrpaIXH","row":"Zkt1ki_nqa6GW3DV3K1n"};